// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3E1iT","info":"PatientInfo_info__3BDTp"};